import React from 'react';
import { useEventListener } from './useEventListener';

const useUserLeavingApp = () => {
  const [isUserLeaving, setIsUserLeaving] = React.useState(false);
  const [noAttemptsToLeave, setNoAttemptsToLeave] = React.useState(0);

  const handleMouseOut = (e) => {
    const event = e || window.event;
    const relatedTarget = event.relatedTarget || event.toElement;

    if ((!relatedTarget || relatedTarget.nodeName === 'HTML') && event.clientY <= 100) {
      // We need both state to update at the same time
      setNoAttemptsToLeave(() => {
        setIsUserLeaving(true);
        return noAttemptsToLeave + 1;
      });
    } else if (isUserLeaving) {
      setIsUserLeaving(false);
    }
  };

  useEventListener('mouseout', handleMouseOut);

  return [isUserLeaving, noAttemptsToLeave];
};

export default useUserLeavingApp;
